// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"d00eec89","208":"b525d867","264":"d6b03914","648":"d6b03914","828":"776caf7b"}[chunkId] + ".chunk.css";
};